import { AlertIcon, MeetModal, meetBtn, WarningIcon } from "./MeetModal";
import type { ExitDecision } from "./meetRules";

/**
 * "Salir de la sesión" con fricción (política de tolerancia). Nunca bloquea del todo: una caída de internet o una emergencia personal
 * no pueden dejar a la psicóloga atrapada. La decisión sale de `decideExit`; acá solo se muestra y se elige.
 */
export function ExitGate({
  decision,
  onStay,
  onReportAbsence,
  onLeave,
}: {
  decision: ExitDecision | null;
  onStay: () => void;
  onReportAbsence: () => void;
  onLeave: () => void;
}) {
  if (decision?.kind === "wait-patient") {
    return (
      <MeetModal
        open
        onClose={onStay}
        icon={<WarningIcon />}
        title="Tu paciente todavía no se conectó"
        actions={
          <>
            {decision.absenceReported && (
              <button className={meetBtn.ghost} onClick={onLeave}>
                Salir igual
              </button>
            )}
            {!decision.absenceReported && (
              <button className={meetBtn.secondary} onClick={onReportAbsence}>
                Reportar ausencia
              </button>
            )}
            <button className={meetBtn.primary} onClick={onStay} autoFocus>
              Seguir en la llamada
            </button>
          </>
        }
      >
        <div className="mb-3 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-center">
          <p className="text-3xl font-extrabold tabular-nums text-amber-800">
            {decision.minutesToTolerance} min
          </p>
          <p className="text-xs font-medium uppercase tracking-wide text-amber-700">
            para cumplir la tolerancia de 35 min
          </p>
        </div>
        {decision.absenceReported ? (
          <p>
            Ya registraste la ausencia, pero la política de Psi Mammoliti pide
            esperar hasta el minuto 35. Si salís ahora, queda registrado que
            saliste antes.
          </p>
        ) : (
          <p>
            La política de Psi Mammoliti pide esperar al paciente hasta el
            minuto 35. Si se conecta, podés dar la sesión por el tiempo que
            quede.
          </p>
        )}
      </MeetModal>
    );
  }
  if (decision?.kind === "confirm-short") {
    return (
      <MeetModal
        open
        onClose={onStay}
        icon={<AlertIcon />}
        title="¿Salir de la sesión?"
        actions={
          <>
            <button className={meetBtn.ghost} onClick={onLeave}>
              Salir
            </button>
            <button className={meetBtn.primary} onClick={onStay} autoFocus>
              Seguir en la llamada
            </button>
          </>
        }
      >
        <p>
          Van {decision.minutesElapsed} min y la política pide un mínimo de{" "}
          {decision.minimumMin}. Si el paciente ya se despidió, podés salir.
        </p>
      </MeetModal>
    );
  }
  return null;
}
